export const communityExtractedMessages = {
  "community.CommunityPage.blockedReaders": "Blocked readers",
  "community.CommunityPage.community": "Community",
  "community.CommunityPage.dismiss": "Dismiss",
  "community.CommunityPage.hideReview": "Hide review",
  "community.CommunityPage.moderationQueue": "Moderation queue",
  "community.CommunityPage.noOpenReports": "No open reports.",
  "community.CommunityPage.allQueueLanguages": "All queue languages",
  "community.CommunityPage.originalEvidence": "Original evidence",
  "community.CommunityPage.queueLanguage": "Queue language",
  "community.CommunityPage.targetLanguage": "Target language: {language}",
  "community.CommunityPage.machineTranslatedEvidence":
    "Machine translated from {language}",
  "community.CommunityPage.translateForReview": "Translate for review",
  "community.CommunityPage.translationUnavailable":
    "An approved cached translation is not available.",
  "community.CommunityPage.publishedReaderReviewsYourProfileAndReading":
    "Published reader reviews. Your profile and reading data stay private until you choose otherwise in Settings.",
  "community.CommunityPage.reporterIdentitiesAreConfidentialEveryDecisionRequires":
    "Reporter identities are confidential. Every decision requires a rationale and creates an audit record.",
  "community.CommunityPage.unblock": "Unblock",
  "community.GroupHub.bookClubs": "Book clubs",
  "community.GroupHub.clubModeratorsCanCreateAChallengeFor":
    "Club moderators can create a challenge for their members.",
  "community.GroupHub.clubName": "Club name",
  "community.GroupHub.clubsAndChallenges": "Clubs and challenges",
  "community.GroupHub.communityNotifications": "Community notifications",
  "community.GroupHub.clubDigest": "Club digest",
  "community.GroupHub.discussionReplies": "Discussion replies",
  "community.GroupHub.pollsAndEvents": "Polls and events",
  "community.GroupHub.challengeUpdates": "Challenge updates",
  "community.GroupHub.create": "Create",
  "community.GroupHub.createAClub": "Create a club",
  "community.GroupHub.createAPrivateClubOrJoinA":
    "Create a private club or join a public one.",
  "community.GroupHub.groupParticipationIsOptInChallengeProgress":
    "Group participation is opt-in. Challenge progress is never shared unless you enable it for that challenge.",
  "community.GroupHub.inviteOnly": "Invite only",
  "community.GroupHub.join": "Join",
  "community.GroupHub.joinAndShareProgress": "Join and share progress",
  "community.GroupHub.members": "members",
  "community.GroupHub.noVisibleChallenges": "No visible challenges",
  "community.GroupHub.noVisibleClubs": "No visible clubs",
  "community.GroupHub.private": "Private",
  "community.GroupHub.public": "Public",
  "community.GroupHub.sharedChallenges": "Shared challenges",
  "community.GroupHub.turnOffHighVolumeUpdatesAtAny":
    "Turn off high-volume updates at any time.",
  "community.GroupHub.visibility": "Visibility",
  "community.GroupHub.yourSharedProgress": "Your shared progress:",
  "community.ReviewPanel.block": "Block",
  "community.ReviewPanel.allLanguages": "All languages",
  "community.ReviewPanel.contentLanguage": "Content language",
  "community.ReviewPanel.machineTranslatedFrom": "Machine translated from {language}",
  "community.ReviewPanel.showOriginal": "Show original",
  "community.ReviewPanel.translate": "Translate",
  "community.ReviewPanel.translationUnavailable": "Translation unavailable",
  "community.ReviewPanel.communityContentCouldNotBeLoaded":
    "Community content could not be loaded",
  "community.ReviewPanel.containsSpoilers": "Contains spoilers",
  "community.ReviewPanel.revealAfterPercent": "Reveal after reading (%)",
  "community.ReviewPanel.revealAfterCompletion": "Reveal after completion",
  "community.ReviewPanel.deleteRating": "Delete rating",
  "community.ReviewPanel.noPublicReviews": "No public reviews",
  "community.ReviewPanel.outOf5Stars": "out of 5 stars",
  "community.ReviewPanel.publishedReviewsWillAppearHere":
    "Published reviews will appear here.",
  "community.ReviewPanel.rating": "Rating",
  "community.ReviewPanel.readerReviews": "Reader reviews",
  "community.ReviewPanel.report": "Report",
  "community.ReviewPanel.revealSpoiler": "Reveal spoiler",
  "community.ReviewPanel.reviewOptional": "Review (optional)",
  "community.ReviewPanel.reviewTitleOptional": "Review title (optional)",
} as const;
